module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid15_800x600.5c48dac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid15_800x600.jpg
// module id = tw9i
// module chunks = 0